<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
    <div class="d-header clearfix">
      <div class="fl">
        <i class="el-icon-info"/>
        {{ dataId ? '查看' : '新增' }}岗位信息
      </div>
      <div class="fr">
        <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
      </div>
    </div>
    <div>

      <!-- 品牌信息 -->
      <div class="d-cont edit-mce-box">
        <div class="d-item">
          <div class="title first">
            <b>基本信息</b>
          </div>
          <table class="table-detail">
            <tbody>
            <tr>
              <th>
                <em class="f-red">*</em>
                岗位名称</th>
              <td>
                <el-input type="text" autocomplete="off" v-model="formData.postName" @blur="inspection" clearable/>
           
              </td>
              <th>
                <em class="f-red">*</em>
                岗位标识
              </th>
              <td>
                <el-input type="text" autocomplete="off" v-model="formData.postCode" @blur="inspection" clearable/>
              </td>
              <th>
                <em class="f-red">*</em>

          岗位排序
              </th>
              <td>
                <el-input type="number" autocomplete="off" v-model="formData.postSort" clearable/>
              </td>
            </tr>

            </tbody>
          </table>
        </div>
      </div>
    </div>
    </el-form>
  </div>
</template>
<script>
import {editPageMixins} from '@/mixins/tabChang'
import Tinymce from '@/components/Tinymce';
import pager from '@/components/pager/index.vue';
import PhotoUpload from "@/components/formItem/photoUpload.vue"
import ItemCategorySelect from "@/components/formItem/itemCategorySelect.vue"
import api from "@/api/projectApi";
import OrgSearch from "@/components/formItem/orgSearch.vue";
import {addObj, delObj, fetchList, fetchRoleTree, permissionUpd, putObj} from '@/api/admin/role'



export default {
  inject: ['reload'],

  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  mixins: [editPageMixins],
  components: {
    OrgSearch,
    ItemCategorySelect,
    PhotoUpload,
    Tinymce,
    pager
  },
  data() {
    return {
      showItemPop: false,
      options: [{
          value: '0',
          label: 'CTO'
        }, {
          value: '1',
          label: 'CEO'
        }],

      value: '',
      activeName: 'first',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      formData: {
        postName:'',
        postCode:'',
        postSort:'',
        createTime:'',


      },

      rules: {
        brandId: [{required: true, prop: '品牌'}],
        itemCode: [{required: true, prop: '产品编码', type: 'string', maxlength: 10}],
        itemName: [{required: true, prop: '产品名称', type: 'string', maxlength: 50}],
        itemMold: [{required: false, prop: '产品型号', type: 'string', maxlength: 50}],
        bigCategoryId: [{required: true, prop: '产品大类'}],
        smallCategoryId: [{required: true, prop: '产品小类'}],
        guaranteePeriodMonthes: [{required: false, prop: '保修期(按月)', type: 'number', min: 0, max: 9999}],
        serviceIntervalMonthes: [{required: false, prop: '保养周期(按月)', type: 'number', min: 0, max: 9999}],
      },


      showProductCategoryDialog: false,
      selectedData: []
    };
  },
  watch: {
    'formData.brandId': {
      handler(n) {
        console.log(n)
      },
      deep: true
    }
  },
  computed: {
    getExcludeIdList() {
      let temp = []
      if (this.formData.id) {
        temp.push(this.formData.id)
      }
      if (this.formData.basItemPackageDTOList) {
        temp.push(...this.formData.basItemPackageDTOList.map(item => item.packageItemId))
      }
      return temp
    }
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },
  mounted() {
    this.getData();
    console.log(this.formData, "formData的值");
    console.log(this._dataId, "_dataId的值");
  },
  methods: {
    inspection() {
      if (this.formData.itemCode) {
        this.$http.post(api.basItem.inspectionUrl, {value: this.formData.itemCode, id: this.formData.id,}).then(res => {
          if (!res.data.data) {
            this.$message.warning("产品编码已存在，请重新输入")
            this.formData.itemCode = null
          }
        })
      }
    },


    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
                url: '/admin/post/'+this._dataId,
                method: `get`,
              }).then((response) => {
                     this.formData = response.data.data;
              }).catch(e => {
              })
      }
    },

    saveData() {
        this.$refs.editForm.validate(valid => {
          if (valid) {
            this.$baseConfirm('您确定要保存吗？').then(() => {
              this.$mask.open()

              // this.$http({
              //   url: '/admin/user',
              //   method: `post`,
              //   data: this.formData
              // }).then(() => {
              //   this.$message.success("保存成功！");
              //   this.reload()
              //   // this.$emit('editViewDataUpdate')
              // }).catch(e => {
              //   console.error(e)
              //   this.$message.error("保存失败！");
              // })
              if(this._dataId==0){
                         this.$http({
                url: '/admin/post',
                method: `post`,
                data: this.formData
              }).then(() => {
                this.$message.success("保存成功！");
                this.$mask.close()

                this.reload()
                // this.$emit('editViewDataUpdate')
              }).catch(e => {
                console.error(e)
                this.$message.error("保存失败！");
                this.$mask.close()

              })
              }else{
                this.$http({
                url: '/admin/post',
                method: `put`,
                data: this.formData
              }).then(() => {
                this.$message.success("修改成功！");
                this.reload()
                this.$mask.close()

                // this.$emit('editViewDataUpdate')
              }).catch(e => {
                console.error(e)
                this.$message.error("保存失败！");
                this.$mask.close()

              })
              }
            })
          }
        })
      },
    // saveData () {
    //   if (this.formData.phone && this.formData.phone.indexOf("*") > 0) {
    //     this.formData.phone = undefined;
    //   }
    //   addObj(this.formData)
    //     .then(() => {
        
    //       this.$notify.success("创建成功");
    //     })
    //     .catch(() => {
   
    //       console.log("失败了");
    //     });
    // },

    commit(data) {
      console.log(data, '弹框选中')
      let temp = []
      data.forEach(item => {
        temp.push({
          id: -new Date().getTime() + Math.floor(Math.random() * 1000),
          packageItemId: item.id,
          brandName: item.brandName,
          itemCode: item.itemCode,
          itemName: item.itemName,
          itemModel: item.itemModel,
          packageQty: 1,
          isNew: true
        })
      })
      if (!this.formData.basItemPackageDTOList) this.formData.basItemPackageDTOList = []
      this.formData.basItemPackageDTOList.push(...temp)
    },

    deleteData() {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        let temp = this.formData.basItemPackageDTOList
        this.selectedData.forEach(item => {
          temp = temp.filter(item1 => item1.id != item.id)
        })
        this.formData.basItemPackageDTOList = temp
      })
    },

    selectChangeEvent({records}) {
      console.log('选中', records)
      this.selectedData = records
    },


  },
};

</script>
<style lang="scss" scoped>
// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 165px !important;
}
.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}
.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}
::v-deep .el-select__tags > span{
  display: flex !important;;
}
</style>
